import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 24 24' className={className}>
      <path
        d='M19.3075652,5 L5.35910145,5 C4.05831884,5 3,6.08361095 3,7.41548016 L3,16.5845198 C3,17.9163891 4.05831884,19 5.35910145,19 L19.3075652,19 C20.6083478,19 21.6666667,17.9163891 21.6666667,16.5845198 L21.6666667,7.41548016 C21.6666667,6.08361095 20.6083478,5 19.3075652,5 Z M18.939,6.55810623 L12.3333333,11.7828519 L5.72766667,6.55810623 L18.939,6.55810623 Z M19.3075652,17.4419976 L5.35910145,17.4419976 C4.8974058,17.4419976 4.52173913,17.0573531 4.52173913,16.5846237 L4.52173913,7.57316051 L11.8681884,13.383858 C12.0051449,13.4921983 12.1692899,13.5463166 12.3333333,13.5463166 C12.4973768,13.5463166 12.6615217,13.4921983 12.7984783,13.383858 L20.1449275,7.57316051 L20.1449275,16.5845198 C20.1449275,17.0573531 19.7692609,17.4419976 19.3075652,17.4419976 Z'
        fill={fillColor}
      />
    </svg>
  );
});

export default React.memo(Icon);
